<template>
    <div class="page">
        <HeaderBar :inputName="practiceName" />
        <div :class="bodyClass">
            <div class="component-window">
                <transition name="fade" mode="out-in">
                    <component :is="components[currentComponent].name" v-bind="components[currentComponent].props" @ToOverview="GoToOverview()" @LoadPlan="LoadPlan()" @switchComponent="NavigateToComponent" @emitDataPageOne="swapComponent(true)" @planSubmitted="NavigateToComponent(NavigateToComponentByName('loading'))" @landingPageChecking="toggleIsCheckingLandingPage()" @landingPageAvailable="setLandingPageAvailable($event)" :key="currentComponent"></component>
                </transition>
            </div>
        </div>
        <div class="footer-spacer"></div>
        <FooterBar v-if="currentComponent > 0 && mode !== 'view'" :right-text="footerRightText" :left-text="footerLeftText" :blue-circle="footerBlueCircle" @NextPage="swapComponent(true)" @PrevPage="swapComponent(false)"/>
    </div>
  </template>
  
  <script>
    import HeaderBar from './components/HeaderBar.vue';
    import FooterBar from './components/FooterBar.vue';
    import PageOne from './components/PageOne.vue';
    import UCRInformation from './components/UCRInfo.vue';
    import PlanPricing from './components/PlanPricing.vue'
    import EnrollmentFee from './components/EnrollmentFee.vue';
    import PlanPriceDiscounts from './components/PlanPriceDiscounts.vue';
    import Rewards from './components/Rewards.vue';
    import AddOns from './components/AddOns.vue';
    import PlanOverview from './components/PlanOverview.vue';
    import LoadingScreen from'./components/LoadingScreen.vue';
    import ContactPage from './components/ContactInfo.vue'
    import { GetPlanFromDB, NavigateToComponentByName, GetComponentNumber } from './utils/functions.js'

    import { mapActions } from 'vuex';
  
    export default {
        props: {
            planConfigCode: String,
            inputMode: String,
        },
        components: {
            HeaderBar,
            FooterBar,
            PageOne,
            UCRInformation,
            PlanPricing,
            AddOns,
            EnrollmentFee,
            PlanPriceDiscounts,
            Rewards,
            PlanOverview,
            LoadingScreen,
            ContactPage,
        },
        data() {
            return {
                currentComponent: 0,
                practiceName: "",
                practiceZip: null,
                footerRightText: "",
                footerLeftText: "",
                footerBlueCircle: 1,
                pageTwoUserTriedToAdvance: false,
                contactPageUserTriedToAdvance: false,
                mode: "",
                getPlanStatus: 0,
                isCheckingLandingPage: false,
                landingPageAvailable: false,
            };
        },
        methods: {
            ...mapActions([
            'setIsFreshIntake',
            'setAdultPlanSet',
            'setChildPlanSet',
            'updatePracticeName',
            'updatePracticeZip',
            'updateBenefitByIDStore',
            'setUCRsDemoStore',
            'setUCRsMainStore',
            'setBenefitPricesAtUCRStore',
            'setBenefitPricesBelowUCRStore',
            'setEverything']),
            swapComponent(shouldGoForward) {
                //console.log("Leaving component: ", this.currentComponent);
                //console.log("Entering swapComponent")
                if(shouldGoForward) {
                    if(this.currentComponent === GetComponentNumber('ucrinfo')) { // UCR_INFORMATION
                        // if(this.$store.state.benefits[5].UCR === null) {
                        //     let new_benefit = this.$store.getters.getBenefitByID(5);
                        //     new_benefit.UCR = 40;
                        //     this.updateBenefitByIDStore(new_benefit);
                        // }
                        // if(this.$store.state.benefits[6].UCR === null) {
                        //     let new_benefit = this.$store.getters.getBenefitByID(6);
                        //     new_benefit.UCR = 40;
                        //     this.updateBenefitByIDStore(new_benefit);
                        // }
                        this.pageTwoUserTriedToAdvance = true;
                        if(!this.$store.getters.benefitUCRsAllFilled()) {
                            return;
                        }
                        else {
                            if((this.mode === 'main' || this.mode === 'demo')
                                ||
                                (this.mode === 'build' && this.$store.state.isFreshIntake === true)){
                                    //console.log("Inside of code block")
                                    if (!this.$store.state.ucrsSet) {
                                        //console.log("Setting prices to UCR")
                                        this.setBenefitPricesAtUCRStore();
                                    }
                                    this.setBenefitPricesBelowUCRStore();
                                    this.setIsFreshIntake(false)
                                }
                        }
                    }
                    if(this.currentComponent === GetComponentNumber('adult')) { // ADULT_PRICING
                        //console.log("Setting Adult Plan Set");
                        this.setAdultPlanSet();
                    }
                    if(this.currentComponent === GetComponentNumber('child')) { // CHILD_PRICING
                        this.setChildPlanSet();
                    }
                    if(this.currentComponent === GetComponentNumber('contact')) { // CONTACT_INFO
                        this.contactPageUserTriedToAdvance = true;
                        if(this.$store.state.practiceName == "") {
                            return;
                        }
                    }
                    
                    this.currentComponent++;
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth' // Optional: for smooth scrolling
                    });
                }
                else {
                    this.currentComponent--;
                }
                //console.log("Current component: ", this.currentComponent);
                //BACK BUTTON
                //window.history.pushState({ currentComponent: this.currentComponent }, '', '#' + this.components[this.currentComponent].name);
                this.setFooterData();
            },
            GoToOverview() {
                //console.log("Going to overview")
                this.currentComponent = GetComponentNumber('contact'); // CONTACT_INFO
            },
            getComponentDisplayName(componentNumber) {
                // Map component numbers to their display names
                const displayNames = {
                    [GetComponentNumber('pageone')]: "Initial Information",
                    [GetComponentNumber('ucrinfo')]: "UCR Information",
                    [GetComponentNumber('adult')]: this.$store.getters.getPlanTypeFromInt(0) + " Plans",
                    [GetComponentNumber('child')]: this.$store.getters.getPlanTypeFromInt(1) + " Plans",
                    [GetComponentNumber('perio')]: this.$store.getters.getPlanTypeFromInt(2) + " Plans",
                    [GetComponentNumber('addons')]: "Add-Ons",
                    [GetComponentNumber('planpricediscounts')]: "Plan Price Discounts",
                    [GetComponentNumber('enrollment')]: "Enrollment Fees",
                    [GetComponentNumber('rewards')]: "Rewards",
                    [GetComponentNumber('contact')]: "Contact Information",
                    [GetComponentNumber('overview')]: "Plan Overview",
                    [GetComponentNumber('loading')]: "Loading",
                };
                return displayNames[componentNumber] || "";
            },
            getNextComponent() {
                // Calculate the next component, accounting for demo mode skips
                let nextComponent = this.currentComponent + 1;
                
                // Return empty string if we're at the last component
                if (nextComponent > GetComponentNumber('overview')) {
                    return "";
                }
                
                return this.getComponentDisplayName(nextComponent);
            },
            getPreviousComponent() {
                // Calculate the previous component, accounting for demo mode skips
                let prevComponent = this.currentComponent - 1;
                
                // Return empty string if we're at the first component (or before it)
                if (prevComponent < GetComponentNumber('ucrinfo')) {
                    return "";
                }
                
                return this.getComponentDisplayName(prevComponent);
            },
            getBlueCircleNumber() {
                // Determine the blue circle indicator based on current component
                const component = this.currentComponent;
                
                if (component >= GetComponentNumber('ucrinfo') && component <= GetComponentNumber('addons')) {
                    return 1;
                } else if (component === GetComponentNumber('planpricediscounts')) {
                    return 2;
                } else if (component >= GetComponentNumber('enrollment') && component <= GetComponentNumber('rewards')) {
                    return 2;
                } else if (component === GetComponentNumber('contact')) {
                    return 3;
                } else if (component === GetComponentNumber('overview')) {
                    return 0;
                }
                
                return 0; // Default for other components
            },
            setFooterData() {
                // Dynamically calculate footer text and blue circle
                this.footerLeftText = this.getPreviousComponent();
                this.footerRightText = this.getNextComponent();
                this.footerBlueCircle = this.getBlueCircleNumber();
            },
            unlockExamXRayPrices() {
                this.setAdultPlanSet();
            },
            setPracticeNameLocal() {
                this.updatePracticeName(this.practiceName)
            },
            setPracticeZipLocal() {
                this.updatePracticeZip(this.practiceZip)
            },
            async LoadPlan() {
                //console.log("Entering LoadPlan")
                //send user to a loading screen, execute this logic, then redirect to Plan Overview?
                //console.log("Code = ", this.planConfigCode);
                try {
                    const returnData = await GetPlanFromDB(this.planConfigCode);
                    if(returnData === 404) {
                        this.getPlanStatus = 404;
                        return;
                    }
                    else if(returnData === 500) {
                        this.getPlanStatus = 500;
                        return;
                    }
                    //console.log("Logging returnData now:");
                    //console.log(returnData)
                    let plan = JSON.parse(returnData.plans);
                    //console.log("Parsed plan in Onboarding.vue = ", plan);
                    plan.id = returnData.id;
                    //console.log("Plan ID = ", plan.id);
                    //console.log("Plan = ", plan)
                    this.setEverything(plan);
                    this.practiceName = plan.practiceName;
                    if(this.mode === 'view') {
                        this.swapComponent(false);
                    }
                    else if(this.mode === 'build') {
                        let componentName = 'ucrinfo'; // UCR_INFORMATION
                        if(this.$store.state.practiceName === "") {
                            componentName = 'pageone'; // PAGE_ONE
                        }
                        this.NavigateToComponent(NavigateToComponentByName(componentName));
                    }
                }
                catch (error) {
                    console.log("Error = ", error);
                }
            },
            NavigateToComponent(payload) {
                this.currentComponent = payload.number;
                //BACK BUTTON
                //window.history.pushState({ currentComponent: payload.number }, '', '#' + this.components[payload.number].name);
                this.setFooterData();
                window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth' // Optional: for smooth scrolling
                    });
            },
            toggleIsCheckingLandingPage() {
                this.isCheckingLandingPage = !this.isCheckingLandingPage;
            },
            setLandingPageAvailable(data) {
                //console.log("Data.available = ", data.available);
                this.landingPageAvailable = data.available;
            },
            handleBeforeUnload(event) {
                if (this.hasUnsavedChanges) {
                    event.preventDefault();
                    event.returnValue = '';
                }
            },
            //BACK BUTTON
            // handlePopState(event) {
            //     if (event.state) {
            //         this.currentComponent = event.state.currentComponent;
            //         this.setFooterData();
            //     }
            // },
        },
        
        mounted() {
            this.setFooterData();
            if(this.mode === 'demo') {
                this.setPracticeNameLocal()
            }
            window.addEventListener('beforeunload', this.handleBeforeUnload);
            //BACK BUTTON
            //window.history.replaceState({ currentComponent: this.currentComponent }, '', '#' + this.components[this.currentComponent].name);

            //BACK BUTTON
            //console.log("Adding event listener")
            //window.addEventListener('popstate', this.handlePopState.bind(this));
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
        },
        created() {
            if(this.inputMode === "main") {
                this.mode = 'main';
                this.currentComponent = GetComponentNumber('pageone'); // PAGE_ONE
                this.setUCRsMainStore();
            }
            else if(this.inputMode === "demo") {
                this.mode = 'demo';
                this.currentComponent = GetComponentNumber('ucrinfo'); // UCR_INFORMATION
                this.practiceName = "Demo Dental"
                this.setUCRsDemoStore();
            }
            else if (this.inputMode === "view") {
                this.mode = 'view';
                this.currentComponent = GetComponentNumber('loading'); // LOADING_SCREEN
                this.footerBlueCircle = 0;
            }
            else if(this.inputMode === "build") {
                this.mode = 'build';
                this.currentComponent = GetComponentNumber('loading'); // LOADING_SCREEN
            }
        },
        // beforeDestroy() {
        //      BACK BUTTON
        //     window.removeEventListener('popstate', this.handlePopState);
        // },
        computed: {
            store() {
                return this.$store.state
            },
            hasUnsavedChanges() {
                const state = this.$store.state;
                if (!state.uneditedState) return false;
                const fieldsToCheck = [
                    'benefits', 'plans', 'percentBreakage', 'includeDMFee',
                    'includeProcessingFee', 'isPediatric', 'dentalMenuFee',
                    'rewardsPointsPerVisit', 'reimbursementPercentage',
                    'includePointsInPlanPrice', 'rewardsEnabled', 'enrollmentFee',
                    'enrollmentFeeFirstVisit', 'firstVisitReimbursement', 'staffIncentive',
                    'StaffIncentiveActive', 'existingPatientEnrollmentDiscount',
                    'ExistingMemberDiscountActive', 'baseEnrollmentFee', 'planTypes',
                    'monthlyDiscounts', 'treatmentDiscounts', 'otherDiscounts', 'addOns',
                    'coupons', 'practiceName', 'practiceEmail', 'practiceWebsite',
                    'landingPage', 'practiceAddress', 'addressLineTwo', 'practiceCity',
                    'practiceState', 'practiceZip', 'practicePhone', 'includeBrochures',
                    'brochureStyle', 'brochureColors', 'note', 'planNote',
                ];
                return fieldsToCheck.some(
                    field => JSON.stringify(state[field]) !== JSON.stringify(state.uneditedState[field])
                );
            },
            bodyClass() {
                return {
                    'body': true,
                    'body-page-one': this.currentComponent === GetComponentNumber('pageone') // PAGE_ONE
                }
            },
            components() {
                return [
                    {
                        name: "PageOne",
                        props: {},
                    },
                    {
                        name: "UCRInformation",
                        props: {parentUserTriedToAdvance: this.pageTwoUserTriedToAdvance, mode: this.mode}
                    },
                    {
                        name: "PlanPricing",
                        props: {planType: 0, mode: this.mode}
                    },
                    {
                        name: "PlanPricing",
                        props: {planType: 1, mode: this.mode}
                    },
                    {
                        name: "PlanPricing",
                        props: {planType: 2, mode: this.mode}
                    },
                    {
                        name: "AddOns",
                        props: {mode: this.mode}
                    },
                    {
                        name: "PlanPriceDiscounts",
                        props: {mode: this.mode}
                    },
                    {
                        name: "EnrollmentFee",
                        props: {mode: this.mode}
                    },
                    {
                        name: "Rewards",
                        props: {mode: this.mode}
                    },
                    {
                        name: "ContactPage",
                        props: {userTriedToAdvance: this.contactPageUserTriedToAdvance, mode: this.mode}
                    },
                    {
                        name: "PlanOverview",
                        props: {mode: this.mode, code: this.planConfigCode}
                    },
                    {
                        name: "LoadingScreen",
                        props: {getPlanStatus: this.getPlanStatus}
                    },
                ]
            }
        }

}
  </script>
  
  <style scoped>
 
  .body {
    height: auto;
    min-height: calc(100vh - var(--header-height) - var(--footer-height));
    display: flex;
    flex-direction: column;
    background-color: var(--color-teal-background);
  }

  .body-page-one {
    align-items: center;
    justify-content: center;
  }
  
  .component-window {
    height: 90%;
    width: 75%;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .footer-spacer {
    height: var(--footer-height);
    background-color: rgba(226,239,237,255);
  }
  </style>
  
